import { SvelteToast, toast } from "@zerodevx/svelte-toast";

const app = new SvelteToast({
  // Set where the toast container should be appended into
  target: document.body,
  props: {
    options: {
      // Optionally set default options here
    },
  },
});

export function showToast(text, state) {
  let options = {
    theme: {},
  };
  if (document.body.clientWidth < 500) {
    options.reversed = true;
    options.intro = { y: 10 };
  }

  switch (state) {
    case "SUCCESS":
      options.theme = {
        "--toastBackground": "#48BB78",
        "--toastProgressBackground": "#2F855A",
      };
      break;

    case "ERROR":
      options.theme = {
        "--toastBackground": "#F56565",
        "--toastProgressBackground": "#C53030",
      };
      break;
    default:
      break;
  }

  toast.push(text, options);
}
